const handleMouseover = ({ target }) => {
  const { localName } = target;
  const value = localName === 'select' ? target.selectedOptions[0].innerText : target.value;
  const isTextOverflow = localName === 'select'
    ? true
    : target.clientWidth !== target.scrollWidth;
  const displayedValue = isTextOverflow ? value : '';
  target.setAttribute('title', displayedValue);
};

const setTitleToFilters = () => {
  const elements = document.querySelectorAll([
    '[data-tooltip-type="select"] select',
    '[data-tooltip-type="text"] input',
    '[data-tooltip-type="datetime"] input',
  ].join(','));
  [...elements].forEach((el) => el.addEventListener('mouseover', handleMouseover));
};

export default setTitleToFilters;



// WEBPACK FOOTER //
// ./src/common/filtersTitles.js